<template>
  <el-dialog
    :custom-class="customClass"
    :visible.sync="dialogVisible"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :title="title"
    v-bind="$attrs"
    @close="handleClose"
  >
    <slot></slot>
  </el-dialog>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        console.log(val, "====");
        this.dialogVisible = val;
      },
    },
  },
  computed: {
    customClass() {
      if (this.size === "small") {
        return this.isH5
          ? "saas-web-dialog__small mg-dialog__h5"
          : "saas-web-dialog__small";
      } else if (this.size === "middle") {
        return this.isH5
          ? "saas-web-dialog__middle mg-dialog__h5"
          : "saas-web-dialog__middle";
      } else {
        return this.isH5
          ? "saas-web-dialog__large mg-dialog__h5"
          : "saas-web-dialog__large";
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      isH5: isH5(),
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("cancel");
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__title {
    font-weight: 500;
    color: $saas-text-color;
  }
  .el-dialog__close {
    font-weight: bold;
  }
  .el-button--primary {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    height: 36px;
    min-width: 70px;
    border-radius: 6px;
    padding: 0 15px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%) !important;
    border: unset;
  }
  .el-button--default {
    background: #f2f3f5;
    height: 36px;
    min-width: 70px;
    border-radius: 6px;
    padding: 0 15px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    color: #4e5969;
  }
  .el-button--default:focus,
  .el-button--default:hover {
    background: #f2f3f5;
    border: unset;
  }
  .el-dialog__body {
    .el-form {
      .el-form-item__label {
        color: #515350;
      }
      .el-form-item__content {
        .el-input__inner,
        .el-textarea__inner {
          border-radius: 6px;
          font-size: 14px;
          color: #0d1400;
          &::placeholder {
            color: #575859;
          }
        }
      }
    }
    .el-checkbox {
      .el-checkbox__label {
        padding-left: 0;
        font-weight: normal;
        color: #515350;
      }
    }
  }
}
::v-deep .saas-web-dialog__small.el-dialog {
  width: 380px;
  border-radius: 18px;
  .el-dialog__header {
    padding-top: 24px;
    padding-bottom: 12px;
    .el-dialog__headerbtn {
      right: 10px;
      top: 6px;
    }
  }
  .el-dialog__title {
    font-size: 14px;
  }
  .el-dialog__body {
    padding: 0 24px 24px 24px;
  }
}
::v-deep .saas-web-dialog__middle.el-dialog {
  width: 480px;
  border-radius: 24px;
  .el-dialog__header {
    padding-top: 42px;
    padding-bottom: 12px;
    .el-dialog__headerbtn {
      right: 20px;
      top: 16;
    }
  }
  .el-dialog__title {
    font-size: 18px;
  }
  .el-dialog__body {
    padding: 0 48px 40px 48px;
  }
}
::v-deep .el-dialog.mg-dialog__h5 {
  width: 9.3333rem;
  max-height: 80%;
  overflow: auto;
  border-radius: 0.48rem;
  .el-dialog__header {
    padding-top: 0.64rem;
    padding-bottom: 0.32rem;
    .el-dialog__headerbtn {
      right: 0.2667rem;
      top: 0.16rem;
    }
  }
  .el-dialog__title {
    font-size: 0.3733rem;
  }
  .el-dialog__body {
    padding: 0 0.64rem 0.64rem 0.64rem;
  }
}
</style>
